import { NDC } from "../../../common/constants";

export const NDCRetrieveReq = (data) => ({
  Query: {
    Filters: {
      OrderID: {
        value: data?.PNR || data.value,
        Owner: data?.carrier || data.Owner,
        Channel: NDC,
      },
    },
  },
});

export const NDCCancelOrderReq = (data) => ({
  Query: {
    OrderID: [
      {
        value: data?.PNR || data.value,
        Owner: data?.carrier || data.Owner,
        Channel: NDC,
      },
    ],
  },
});

export const NDCCancelPaidOrderReq = (data) => ({
  Query: {
    OrderID: [
      {
        value: data?.PNR || data.value,
        Owner: data?.carrier || data.Owner,
        Channel: NDC,
      },
    ],
  },
  ExpectedRefundAmount: {
    Total: {
      value: data?.refundAmount,
      Code: data?.currency,
    },
  },
  Metadata: data?.metadata,
  ...(data?.correlationID ? { CorrelationID: data?.correlationID } : {}),
});

export const NDCRepriceReq = (data) => ({
  orderId: data?.PNR || data.value,
  ownerCode: data?.carrier || data.Owner,
  channel: NDC,
});

export const NDCAcceptOrderReq = (data, booking) => ({
  ownerCode: booking?.carrier,
  orderId: booking?.PNR,
  channel: NDC,
  acceptRepricedOrder: {
    dataMap: data?.dataMap,
    paymentFunctions: [
      {
        paymentProcessingDetails: {
          typeCode: "CA",
          amount: {
            ...data?.repriceResult?.totalPrice?.totalAmount,
            nanos: 0,
          },
        },
      },
    ],
    augmentations: data?.augmentations,
  },
});

export const NDCRequoteReq = (data) => ({
  orderId: data?.PNR || data.value,
  ownerCode: data?.carrier || data.Owner,
  channel: NDC,
});

export const NDCReshopReq = (data) => ({
  Query: {
    Reshop: {
      Actions: [
        {
          ActionType: {
            value: "Cancel",
          },
          OrderItems: {
            OrderItem: data?.orderItems?.map((item) => ({
              OrderItemID: {
                value: item,
                Owner: data?.carrier || data.Owner,
              },
            })),
          },
          OrderID: {
            Owner: data?.carrier || data.Owner,
            Channel: NDC,
            value: data?.PNR || data.value,
          },
        },
      ],
    },
  },
});

export const NDCExchangeReq = (data) => ({
  orderId: data?.PNR || data.value,
  ownerCode: data?.carrier || data.Owner,
  channel: NDC,
  reshopOrder: {
    reshopOrderChoice: {
      serviceOrder: {
        addOfferItem: {
          flightRequest: {
            originDestinationsCriteria: {
              originDestCriteria: data?.originDestCriteria,
            },
          },
          shoppingCriteria: {
            fareCriteria: {
              fareTypeCodes: ["PUBL", "PVT"],
            },
          },
          responseControls: {
            resultPreference: "OPTIMIZED",
          },
        },
        // deleteOrderItems: [
        //   {
        //     orderItemRefId: data?.orderItems,
        //     // retainServiceRefIds: data?.retain,
        //     // ...(data?.retain?.length && { retainServiceRefIds: data?.retain }),
        //     ...(data?.retain?.length
        //       ? { retainServiceRefIds: data?.retain }
        //       : {}),
        //   },
        // ],
        deleteOrderItems: data?.orderItems?.reduce((acc, item, index) => {
          if (item?.FlightItem) {
            acc.push({
              orderItemRefId: item?.OrderItemID?.value,
              ...(data?.retain?.length
                ? { retainServiceRefIds: [data?.retain?.[index]] }
                : {}),
            });
          }
          return acc;
        }, []),
      },
    },
  },
});

export const NDCExchangeRequoteReq = (offer, data) => ({
  orderId: data?.PNR || data.value,
  ownerCode: data?.carrier || data.Owner,
  channel: NDC,
  requoteOrder: {
    selectedOffers: [
      {
        selectedOfferItems: offer?.addOfferItems?.map((item) => {
          return {
            offerItemId: item?.offerItemId,
            paxRefIds: [
              ...new Set(
                item?.offeredServices
                  ?.map((service) => service?.paxRefIds)
                  .flat()
              ),
            ],
            selectedServiceRefIds: item?.offeredServices?.map(
              (service) => service?.serviceId
            ),
          };
        }),
        shoppingResponseId: data?.shoppingResponseId,
        offerRefId: offer?.offerId,
      },
    ],
    // affectedOrderItems: data?.orderItems?.reduce((acc, item) => {
    //   if (item?.FlightItem) {
    //     acc.push({
    //       orderItemRefId: item?.OrderItemID?.value,
    //       retainServiceRefIds:
    //         item?.Associations?.IncludedService?.ServiceReferences,
    //     });
    //   }
    //   return acc;
    // }, []),
    affectedOrderItems: data?.orderItems?.reduce((acc, item, index) => {
      if (item?.FlightItem) {
        acc.push({
          orderItemRefId: item?.OrderItemID?.value,
          ...(data?.retain?.length
            ? { retainServiceRefIds: [data?.retain?.[index]] }
            : {}),
        });
      }
      return acc;
    }, []),
    passengers: data?.passengers,
    augmentations: data?.augmentations,
    // ...(data?.augmentations && { augmentations: data?.augmentations }),
  },
});

export const NDCExchangeAcceptReq = (offer, data) => ({
  orderId: data?.PNR || data.value,
  ownerCode: offer?.requotedOffer?.ownerCode || data?.carrier,
  channel: NDC,
  updateOrderItems: {
    acceptOffers: [
      {
        selectedPricedOffers: [
          {
            selectedOfferItems: offer?.requotedOffer?.addOfferItems?.map(
              (item) => {
                return {
                  offerItemRefId: item?.offerItemId,
                  paxRefIds: [
                    ...new Set(
                      item?.offeredServices
                        ?.map((service) => service?.paxRefIds)
                        .flat()
                    ),
                  ],
                };
              }
            ),
            shoppingResponseRefId: offer?.shoppingResponseId,
            offerRefId: offer?.requotedOffer?.offerId,
            ownerCode: offer?.requotedOffer?.ownerCode || data.carrier,
            channel: NDC,
          },
        ],
      },
    ],
    dataMap: offer?.dataMap,
    paymentFunctions: [
      {
        paymentProcessingDetails: {
          typeCode: "CA",
          amount: data.amount,
        },
      },
    ],
    augmentations: offer?.augmentations,
  },
});
